import React  from 'react';
import { EditGuesser, InputGuesser } from "@api-platform/admin";
import { ReferenceArrayInput, SelectArrayInput, BooleanInput, ReferenceInput, AutocompleteInput } from 'react-admin';
import { RichTextInput } from '@agilie/ra-tinymce-input';

const SubCategoryEdit = (props) => (
  <EditGuesser {...props}>
    <ReferenceArrayInput label="Categories" reference="categories" source="categories">
      <SelectArrayInput source="title" />
    </ReferenceArrayInput>
    <InputGuesser source="name" />
    <InputGuesser source="title" />
    <InputGuesser source="metaTitle" />
    <p>Description:</p>
    <RichTextInput label="Description" source="description"
      apiKey='kajmvp4egjobgynq3phsfqif168so5skv2apq56c5zmjum5a'
      init={{
          height: 500,
          menubar: true,
          plugins: [
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount'
          ],
          toolbar: 'undo redo | formatselect | ' +
              'bold italic backcolor | alignleft aligncenter ' +
              'alignright alignjustify | bullist numlist outdent indent | ' +
              'removeformat | help',
          content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
      }}
    />
    <p>Description SEO (Meta):</p>
    <RichTextInput label="Description SEO (Meta)" source="descriptionSeo"
      apiKey='kajmvp4egjobgynq3phsfqif168so5skv2apq56c5zmjum5a'
      init={{
          height: 500,
          menubar: true,
          plugins: [
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount'
          ],
          toolbar: 'undo redo | formatselect | ' +
              'bold italic backcolor | alignleft aligncenter ' +
              'alignright alignjustify | bullist numlist outdent indent | ' +
              'removeformat | help',
          content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
      }}
    />
    <p>Description Secret:</p>
    <RichTextInput label="Description Secret" source="descriptionSecret"
      apiKey='kajmvp4egjobgynq3phsfqif168so5skv2apq56c5zmjum5a'
      init={{
          height: 500,
          menubar: true,
          plugins: [
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount'
          ],
          toolbar: 'undo redo | formatselect | ' +
              'bold italic backcolor | alignleft aligncenter ' +
              'alignright alignjustify | bullist numlist outdent indent | ' +
              'removeformat | help',
          content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
      }}
    />
    <ReferenceInput
      label="File"
      source="file"
      reference="files"
      perPage={10000}
    >
      <AutocompleteInput optionText="title" />
    </ReferenceInput>
    <BooleanInput source="enabled" defaultValue={true} />
    <BooleanInput source="popular" defaultValue={false} />
    <BooleanInput source="lastPosition" defaultValue={false} />
  </EditGuesser>
  );

export default SubCategoryEdit;